/* eslint-disable */
import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Navigate } from 'react-router-dom'
import ClientRouteBootSkeleton from '@/components/ClientRouteBootSkeleton'
import { resolveClientDefaultPath } from '@/constants/menuPermissionMeta'
import { store } from '@/redux/store'
import { bootstrapPermissionCodes } from '@/utils/bootstrapPermissionCodes'

/**
 * `/client` 精确路径的默认跳转：§4.2.1 优先级 + permissionCodesLoaded（避免未加载完误判为双无）。
 * 自身 useEffect 保证 bootstrap 一定被触发，不再完全依赖 App.js 的 effect（后者有 token 校验等多重 guard 可能被跳过）。
 */
export default function ClientDefaultRedirect () {
  const {
    permissionCodes,
    permissionCodesLoaded,
    permissionCodesFetchFailed,
    permissionCodesFetching
  } = useSelector(state => state.app)

  useEffect(() => {
    if (!permissionCodesLoaded && !permissionCodesFetching && !permissionCodesFetchFailed) {
      bootstrapPermissionCodes(store)
    }
  }, [permissionCodesLoaded, permissionCodesFetching, permissionCodesFetchFailed])

  if (permissionCodesFetchFailed) {
    return <Navigate to="/dashboard" replace />
  }
  if (!permissionCodesLoaded) {
    return <ClientRouteBootSkeleton />
  }
  const to = resolveClientDefaultPath(permissionCodes)
  return <Navigate to={to} replace />
}
